import React from 'react';
import { Modal } from 'react-bootstrap';
import { useWizard } from 'react-use-wizard';
import { Form, Formik } from 'formik';
import * as yup from 'yup';

import { Button } from '../../../../components/button';
import Control from '../../../../components/form/Control';
import text from '../../../../text';
import { onboardingConstants } from './constants';
import { useOnboarding } from './reducer';

const onboardingSchema = yup.object({
  fullName: yup.string().required(),
  phoneNumber: yup.string().required(),
});

const Welcome = () => {
  const [{ fullName, phoneNumber }, dispatch] = useOnboarding();
  const { nextStep } = useWizard();

  const handleSubmit = ({ fullName, phoneNumber }) => {
    dispatch({
      type: onboardingConstants.SET_FULL_NAME,
      payload: fullName,
    });
    dispatch({
      type: onboardingConstants.SET_PHONE_NUMBER,
      payload: phoneNumber,
    });
    nextStep();
  };

  return (
    <>
      <Modal.Header>
        <div className='d-flex flex-column align-items-center flex-fill'>
          <h2 className='text-center w-100 mb-1 font-24'>
            {text('enterDetails')}
          </h2>
          <h6 className='secondary-heading'>{text('tellUsAboutYourself')}</h6>
        </div>
      </Modal.Header>
      <Modal.Body className='pt-0'>
        <Formik
          initialValues={{ fullName, phoneNumber }}
          validationSchema={onboardingSchema}
          onSubmit={handleSubmit}
          validateOnChange
          validateOnMount
        >
          {({
            values,
            errors,
            touched,
            isSubmitting,
            handleChange,
            dirty,
            isValid,
          }) => (
            <Form className='form'>
              <Control
                required
                type='text'
                name='fullName'
                label={text('fullName')}
                value={values?.fullName || ''}
                onChange={handleChange}
                autoComplete='off'
                isFailed={touched.fullName && !!errors.fullName ? true : false}
                isSuccessful={!errors.fullName}
                validationError={errors.fullName}
                placeholder={text('fullNamePlaceholder')}
              />
              <Control
                required
                type='text'
                name='phoneNumber'
                label={text('phoneNumber')}
                value={values?.phoneNumber || ''}
                onChange={handleChange}
                autoComplete='off'
                isFailed={
                  touched.phoneNumber && !!errors.phoneNumber ? true : false
                }
                isSuccessful={!errors.phoneNumber}
                validationError={errors.phoneNumber}
                placeholder={text('phoneNumberPlaceholder')}
              />
              <Button
                type={!isSubmitting && 'submit'}
                disabled={!(dirty && isValid)}
                className='submit-button btn-block w-100'
              >
                {text('nextStep')}
              </Button>
            </Form>
          )}
        </Formik>
      </Modal.Body>
    </>
  );
};

export default Welcome;
